"use client"
import { useEffect, useRef } from "react"
import Chart from "chart.js/auto"

const RadarChartPreview = () => {
  const chartRef = useRef(null)
  const chartInstance = useRef(null)

  useEffect(() => {
    if (chartRef.current) {
      if (chartInstance.current) {
        chartInstance.current.destroy()
      }

      const data = {
        labels: ["Market", "Product", "Sales", "Marketing", "Operations", "Customer Success"],
        datasets: [
          {
            label: "Sample GTM Performance",
            data: [65, 75, 50, 80, 60, 70], // Sample scores for preview
            backgroundColor: "rgba(34, 211, 238, 0.2)", // Light cyan with transparency
            borderColor: "hsl(var(--primary))", // Primary color from CSS
            borderWidth: 3,
            pointBackgroundColor: [
              "hsl(var(--chart-1))",
              "hsl(var(--chart-2))",
              "hsl(var(--chart-3))",
              "hsl(var(--chart-4))",
              "hsl(var(--chart-5))",
              "hsl(var(--chart-1))",
            ],
            pointBorderColor: "#ffffff",
            pointHoverBackgroundColor: "#fff",
            pointHoverBorderColor: "hsl(var(--primary))",
            pointRadius: 5,
            pointHoverRadius: 8,
          },
        ],
      }

      chartInstance.current = new Chart(chartRef.current, {
        type: "radar",
        data: data,
        options: {
          responsive: true,
          maintainAspectRatio: false,
          scales: {
            r: {
              angleLines: { display: true, color: "hsl(var(--muted))" },
              grid: { color: "hsl(var(--muted))" },
              pointLabels: {
                font: { size: 14, family: "Space Grotesk, sans-serif" },
                color: "hsl(var(--foreground))",
              },
              ticks: { stepSize: 20, callback: (value) => value, color: "hsl(var(--foreground))" },
              min: 0,
              max: 100,
              beginAtZero: true,
            },
          },
          plugins: {
            legend: {
              display: true,
              position: "bottom",
              labels: {
                font: { family: "DM Sans, sans-serif", size: 12 },
                color: "hsl(var(--foreground))",
              },
            },
            tooltip: {
              enabled: true,
              callbacks: {
                label: (context) => `${context.label}: ${context.raw}`,
              },
              backgroundColor: "hsl(var(--card))",
              titleColor: "hsl(var(--foreground))",
              bodyColor: "hsl(var(--foreground))",
              borderColor: "hsl(var(--primary))",
              borderWidth: 1,
            },
          },
          elements: {
            line: { tension: 0.3, borderJoinStyle: "round" },
          },
        },
      })
    }

    return () => {
      if (chartInstance.current) {
        chartInstance.current.destroy()
      }
    }
  }, [])

  return (
    <div className="bg-gradient-to-br from-cyan-50 to-blue-50 rounded-lg p-6 shadow-md">
      <h4 className="text-lg font-semibold text-center text-gray-900 mb-4">Sample GTM Assessment</h4>
      <div className="relative w-full h-64">
        <canvas ref={chartRef} />
      </div>
      <p className="text-center text-sm text-gray-600 mt-4">
        This radar chart previews your performance across six GTM dimensions. Take the assessment to see your personalized results!
      </p>
    </div>
  )
}

export default RadarChartPreview